/**
 * Created by dmitry on 14.09.2026
 */

VirtualProducts.initialize = cleverapps.extendFunc(VirtualProducts.initialize, function () {
    this._super();

    const product = VirtualProducts.hardForVideo;
    if (!product) {
        return;
    }

    product.reward = { hard: [10, 30] };

    product.isEnabled = cleverapps.extendFunc(product.isEnabled, function () {
        return this._super() && cleverapps.adsLimits.state(this.adsLimit()) === AdsLimits.STATE_READY;
    });
});
